import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { createPageData, basicFormData } from "./SparePartIssuesFile.js";

import { AvForm } from "availity-reactstrap-validation";
import { formatDate, getRecords } from "../../services/api.service.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../Style/loaderOverly.js";
import { LoaderCreatePage } from "../Loader/Loader.js";

const SparePartIssuesView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, getEndpoint } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [fetchedData, setFetchedData] = useState(null);

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  const getEditData = async (id) => {
    const schema = localStorage.getItem("schema");

    try {
      const payload = {
        modelName: "spare_part_issues",
        schema: schema,

        include: [
          {
            model: "spare_part_requests",
            as: "request",
          },
          {
            model: "user_masters",
            as: "issued_by_user",
          },
        ],
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFormData({ inputData: data });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Spare Part Issues Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate("/spare-part-issues-list")}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Spare Part Request No: </strong>
                                {formData?.inputData?.request
                                  ?.spare_part_request_no || "-"}
                              </p>
                              <p>
                                <strong>Issued Qty: </strong>
                                {formData?.inputData?.issue_qty || "-"}
                              </p>
                              <p>
                                <strong>Issue By: </strong>
                                {formData?.inputData?.issued_by_user
                                  ?.first_name ||
                                formData?.inputData?.issued_by_user?.last_name
                                  ? `${
                                      formData?.inputData?.issued_by_user
                                        ?.first_name || ""
                                    } ${
                                      formData?.inputData?.issued_by_user
                                        ?.last_name || ""
                                    }`
                                  : "-"}
                              </p>
                            </Col>

                            {/* Second Section (Right Side) */}
                            <Col md="6" className="p-3">
                              <p>
                                <strong>Issued At: </strong>
                                {formatDate(formData?.inputData?.issued_at) ||
                                  "-"}
                              </p>

                              <p>
                                <strong>Is Active: </strong>
                                {formData?.inputData?.is_active === true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </AvForm>

                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SparePartIssuesView;
